"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Landing_1 = require("../components/Landing/Landing");
var AboutMe_1 = require("../components/AboutMe/AboutMe");
var Skills_1 = require("../components/Skills/Skills");
var Projects_1 = require("../components/Peojects/Projects");
var Opensource_1 = require("../components/Opensource/Opensource");
require("./user.scss");
var aos_1 = __importDefault(require("aos"));
var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    User.prototype.componentWillReceiveProps = function () {
        aos_1.default.refresh();
    };
    User.prototype.componentDidMount = function () {
        aos_1.default.init({
            once: true,
            duration: 1200
        });
        window.addEventListener('scroll', function () {
            console.log('scrolled:', window.scrollY);
            var floating = document.getElementById('floating-contact');
            floating.style.top = window.scrollY + 300 + "px";
            floating.style.display = "block";
            if (window.scrollY == 0) {
                floating.style.display = "none";
            }
        });
    };
    User.prototype.render = function () {
        return (React.createElement("div", { style: {
                minHeight: window.innerHeight ? window.innerHeight - 80 : 420
            } },
            React.createElement("div", { className: 'floating-container', id: 'floating-contact' },
                React.createElement("div", { className: 'floating-contact-container' },
                    React.createElement("button", { className: 'floating-btn' }, "Contact!"),
                    React.createElement("a", { href: 'https://www.facebook.com/biruktesfayeve', target: '_blank', title: 'facebook' },
                        React.createElement("i", { className: 'fab fa-facebook fa-2x' })),
                    React.createElement("a", { href: 'https://twitter.com/biruktesfayeve', target: '_blank', title: 'follow me on twitter' },
                        React.createElement("i", { className: 'fab fa-twitter fa-2x' })),
                    React.createElement("a", { href: 'https://www.instagram.com/biruktesfayeve/', target: '_blank', title: 'get my latest design works' },
                        React.createElement("i", { className: 'fab fa-instagram fa-2x' })),
                    React.createElement("a", { href: 'http://www.linkedin.com/in/biruktesfayeve', target: '_blank', title: 'see my profile here ' },
                        React.createElement("i", { className: 'fab fa-linkedin fa-2x' })),
                    React.createElement("a", { href: 'https://t.me/BBBBBT6', target: '_blank', title: 'lets talk 24/7' },
                        React.createElement("i", { className: 'fab fa-telegram fa-2x' })))),
            React.createElement(Landing_1.Landing, null),
            React.createElement(AboutMe_1.AboutMe, null),
            React.createElement(Skills_1.Skills, null),
            React.createElement(Projects_1.Projects, null),
            React.createElement(Opensource_1.Opensource, null),
            React.createElement("div", { className: 'find-more-class' },
                React.createElement("div", { className: 'find-title' },
                    React.createElement("h5", null, "explore more about me! "),
                    "\u00A0\u00A0",
                    React.createElement("i", { style: { color: '#f06d6d' }, className: 'far fa-smile-wink fa-2x' })),
                React.createElement("div", { className: 'find-links' },
                    React.createElement("a", { href: "https://codepen.io/biruktesfayeve/", target: '_blank', title: 'designs and animations' },
                        React.createElement("i", { className: 'fab fa-codepen fa-2x' })),
                    React.createElement("a", { href: "https://gitlab.com/biruktf", target: '_blank', title: 'see what i do most! ;) not all of them are public so :(' },
                        React.createElement("i", { className: 'fab fa-gitlab fa-2x' })),
                    React.createElement("a", { href: "https://github.com/biruk-tesfaye", title: 'you wont find much visit gitlab', target: '_blank' },
                        React.createElement("i", { className: 'fab fa-github fa-2x' })),
                    React.createElement("a", { href: "https://www.linkedin.com/in/biruktesfayeve", target: '_blank', title: 'like a pro :)' },
                        React.createElement("i", { className: 'fab fa-linkedin fa-2x' })),
                    React.createElement("a", { href: "https://www.biruktesfayeve@gmail.com", target: '_blank', title: 'lets talk about work!' },
                        React.createElement("i", { className: 'fa fa-envelope fa-2x' })))),
            React.createElement("div", { className: 'footer-container' },
                React.createElement("a", { href: "#" },
                    "Biruk Tesfaye \u00A9 2018 \u00A0 \u00A0 \u00A0made  with love ",
                    React.createElement("i", { className: 'fa fa-heart' })))));
    };
    return User;
}(React.Component));
exports.User = User;



//////////////////
// WEBPACK FOOTER
// ./src/App/index/User.tsx
// module id = 61
// module chunks = 0